import Vue from 'vue'

function getValidationErrorMessage (errorObj) {
  // Was not touched, nothing to validate
  if (!errorObj.$dirty) return null

  const errorMessages = []

  Object.keys(errorObj.$params)
    .filter(key => !errorObj[key])
    .forEach(key => {
      if (errorObj[key]) return

      const validationOptions = errorObj.$params[key]

      if (validationOptions.type === 'required' || validationOptions.type === 'requiredIf') {
        errorMessages.push('A mező kitöltése kötelező')
      } else if (validationOptions.type === 'minLength') {
        errorMessages.push(`Minimum ${validationOptions.min} karakter kötelező`)
      } else if (validationOptions.type === 'numeric') {
        errorMessages.push('A mező csak szám karaktereket tartalmazhat')
      } else if (validationOptions.type === 'validBankAccountNumber') {
        errorMessages.push('Hibás bankszámlaszám')
      } else if (validationOptions.type === 'minValue') {
        errorMessages.push(`Nem lehet kisebb mint ${validationOptions.min}`)
      } else if (validationOptions.type === 'maxValue') {
        errorMessages.push(`Nem lehet nagyobb mint ${validationOptions.max}`)
      } else {
        console.log('Unknown option type: ' + validationOptions.type)
      }
    })

  return errorMessages
}

const getStoreObjectProxy = (attrName, getterName, setterName = null) => {
  const getStoredObject = () => {
    return this.store.getters[getterName]
  }

  const generateDataTarget = vue => {
    const generatedDataProxyHandler = {
      get: (target, property) => {
        if (property[0] !== '$') {
          if (vue.$v && attrName in vue.$v && property in vue.$v[attrName] && vue.$v[attrName][property].$error) {
            Vue.set(target, property, getValidationErrorMessage(vue.$v[attrName][property]))
          } else if (errorVm.backendErrors !== null && property in errorVm.backendErrors) {
            Vue.set(target, property, errorVm.backendErrors[property])
          }
        }

        return target[property]
      }
    }

    const errorVm = new Vue({
      data: {
        backendErrors: null
      },

      computed: {
        errors () {
          const errors = {
            $touch: () => {
              this.$touch()
            },

            $reset: () => {
              this.$reset()
            },

            $error: () => {
              return this.$error()
            },

            $setBackendErrors: backendErrors => {
              this.$setBackendErrors(backendErrors)
            }
          }

          Object.keys(getStoredObject()).forEach(key => {
            errors[key] = null
          })

          return errors
        }
      },

      methods: {
        $touch () {
          if (vue.$v) {
            vue.$v.$touch()
          }
        },

        $reset () {
          this.backendErrors = null
          if (vue.$v) {
            vue.$v.$reset()
          }
        },

        $error () {
          if (this.backendErrors !== null) {
            return true
          }

          if (vue.$v) {
            return vue.$v.$error
          }

          return false
        },

        $setBackendErrors: backendErrors => {
          this.backendErrors = backendErrors
        }
      }
    })

    return {
      $e: new Proxy(errorVm.errors, generatedDataProxyHandler)
    }
  }

  const getProxyHandler = vue => {
    const handler = {
      get: (target, property) => {
        try {
          if (property[0] !== '$') {
            target = getStoredObject()
          }
        } catch (err) {
          return getStoredObject()[property]
        }
        return target[property]
      },

      has: (target, key) => {
        let hasKey = key in getStoredObject()

        if (hasKey === false) {
          hasKey = key in target
        }
        return hasKey
      },

      ownKeys: target => {
        const keys = Object.keys(getStoredObject())
        const targetKeys = Object.keys(target)
        return keys.concat(targetKeys)
      },

      getOwnPropertyDescriptor: (target, prop) => {
        const storedObject = getStoredObject()

        if (prop in storedObject) {
          return Object.getOwnPropertyDescriptor(storedObject, prop)
        } else {
          return Object.getOwnPropertyDescriptor(target, prop)
        }
      }
    }

    if (setterName !== null) {
      handler.set = (target, property, value) => {
        if (property[0] === '$') {
          target[property] = value
        } else {
          this.store.commit(setterName, {name: property, value: value}, {root: true})
          if (vue.$v && attrName in vue.$v && property in vue.$v[attrName]) {
            vue.$v[attrName][property].$touch()
          }
        }
        return true
      }
    }

    return handler
  }

  return {
    get () { return new Proxy(generateDataTarget(this), getProxyHandler(this)) }
  }
}

const proxyStore = mapping => {
  Object.keys(mapping).forEach(key => {
    let config = mapping[key]

    // Only getter provided, setter will be null
    if (typeof config === 'string' || config instanceof String) {
      mapping[key] = getStoreObjectProxy(key, config)
    } else {
      let setter
      if (config.mutation) setter = config.mutation
      else setter = config.setter
      mapping[key] = getStoreObjectProxy(key, config.getter, setter)
    }
  })

  return mapping
}

proxyStore.registerStore = store => {
  this.store = store
}

const proxyStorePlugin = store => {
  proxyStore.registerStore(store)
}

export default proxyStore

export { proxyStorePlugin, getValidationErrorMessage }



// WEBPACK FOOTER //
// ./src/commons/proxyStore.js